import gql from 'graphql-tag'

export const MY_USER = gql`
  query myUser {
    myUser {
      firstName
      lastName
      email
      birthDate
      gender
      height
      unitHeight
      weight
      unitWeight
      billingPlan {
        name
        subscribed
        expire
        canceled
      }
      isSubscribed
    }
  }
`
export const USER_SETTINGS = gql`
  query userSettings {
    myUser {
      firstName
      lastName
      email
      birthDate
      gender
      height
      unitHeight
      weight
      unitWeight
    }
  }
`

export const MY_PLAN = gql`
  query myPlan {
    myUser {
      billingPlan {
        name
        subscribed
        expire
        canceled
      }
      isSubscribed
    }
  }
`

export const CHECK_EMAIL = gql`
  mutation checkEmail($input: String!) {
    checkEmail(input: $input)
  }
`

export const SIGNUP = gql`
  mutation signup($input: SignupInput!) {
    signup(input: $input) {
      _id
    }
  }
`

export const LOGIN = gql`
  mutation login($input: LoginInput!) {
    login(input: $input) {
      user {
        firstName
        lastName
        email
        birthDate
        gender
        height
        unitHeight
        weight
        unitWeight
        billingPlan {
          name
          subscribed
          expire
          canceled
        }
        isAdmin
        isSubscribed
      }
      token
      refreshToken
    }
  }
`

export const UPDATE_USER = gql`
  mutation updateUser($input: UserInput!) {
    updateUser(input: $input) {
      firstName
      lastName
      email
      birthDate
      gender
      height
      unitHeight
      weight
      unitWeight
    }
  }
`

export const CHANGE_PASSWORD = gql`
  mutation changePassword($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      _id
    }
  }
`

export const INITIATE_PASSWORD_RESET = gql`
  mutation initiatePasswordReset($input: PasswordResetInput!) {
    initiatePasswordReset(input: $input) {
      email
    }
  }
`
